import { render, staticRenderFns } from "./OfferDetailFacts.vue?vue&type=template&id=6a204ab2"
import script from "./OfferDetailFacts.vue?vue&type=script&lang=js"
export * from "./OfferDetailFacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports